define('viewModels/privileged/composer/forms/formEditor/MultipleChoiceQuestionAnswer',[
    'lib/knockout',
    'viewModels/ViewModel',
    'viewModels/privileged/composer/vmUtils'
], function (ko, ViewModel, utils) {
    'use strict';

    var MultipleChoiceQuestionAnswerViewModel = ViewModel.extend(
        function multiChoiceAnswer_init(answerModel, formEditorState) {
            var self = this;

            // tracked for changes
            self.text = formEditorState.trackModified(self, answerModel.text);
            self.value = formEditorState.trackModified(self, answerModel.value);

            self.textErrors  = utils.modelErrors(self, answerModel.text);
            self.valueErrors = utils.modelErrors(self, answerModel.value);

            // untracked
            self.modelId = answerModel.modelId;

            self.triggerSelect = function (vm, e) {
                var evt = e.originalEvent || e; //originalEvent, if we've hit a jQuery callback at some point
                evt.ccPreventDeselect = true;

                self.select();

                // NOTE: This must be here to allow checkboxes (etc) to be checked
                return true;
            };

            self.select = function () {
                if (formEditorState.modes.isEditMode()) {
                    formEditorState.selectedItem(self.modelId);
                }
            };

            self.validateCanMoveUp = function() {
                return true;
            };

            self.validateCanMoveDown = function() {
                return true;
            };

            self.unselect = function (vm, e) {
                formEditorState.selectedItem(null);
                e.stopPropagation();
                e.cancelBubble = true;
            };

            self.isFocused = self.computed(function multipleChoiceQuestionAnswerVm_isFocused() {
                return formEditorState.selectedItem() === self.modelId;
            });

            self.scoreReviewValue = function() {
                return ko.i18n.renderString('composer.evaluations.question.scoreValue',
                    { score: self.value });
            };

            self.criticalScoreReviewValue = function() {
                return ko.i18n.renderString('composer.evaluations.question.criticalValue',
                    { critScore: self.value });
            };
        }
    );
    return MultipleChoiceQuestionAnswerViewModel;
});

